import { action } from 'typesafe-actions';
import { IPOSCategories } from 'types';
import { POSCategories } from './types';

export const getPosCategoriesRequest = (siteId: string) => action(POSCategories.GET_POS_CATEGORIES_REQUEST, { siteId });
export const getPosCategoriesSuccess = (response: IPOSCategories) => action(POSCategories.GET_POS_CATEGORIES_SUCCESS, response);
export const getPosCategoriesError = (error: any, failToast?: boolean) => action(POSCategories.GET_POS_CATEGORIES_FAIL, error, { failToast });
